import { useMemo, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import {
  initialBasisMode,
  mapAiResult,
  type OpenCostBasisMode,
} from '@/utils/approval/openConstructionCost';
import OpenConstructionCostReport from './OpenConstructionCostReport';
export { default as OpenConstructionCostSnapshot } from './OpenConstructionCostSnapshot';
import { OpenConstructionCostRoot } from './styles';

type OpenConstructionCostInfoProps = {
  /** 저장·분석 결과 원문(attributes.data) */
  data: unknown[];
};

/** 233 리포트 — 작성·조회 공용. 판정기준(영업이익 ↔ 직접이익) 전환만 화면 상태로 가짐 */
const OpenConstructionCostInfo = ({ data }: OpenConstructionCostInfoProps) => {
  const { i18n } = useTranslation();
  // 분석 전에도 레거시처럼 전 항목 "-" 로 틀을 보여줌
  const view = useMemo(
    () => mapAiResult(data.length ? data : [{}]),
    [data, i18n.language],
  );
  const [mode, setMode] = useState<OpenCostBasisMode | null>(null);
  if (!view) return null;
  const basisMode = mode ?? initialBasisMode(view);
  return (
    <OpenConstructionCostRoot className="open-construction-cost">
      <section id="open_construction_cost_content">
        <OpenConstructionCostReport
          view={view}
          basisMode={basisMode}
          onToggleBasis={() =>
            setMode(basisMode === 'operating' ? 'direct' : 'operating')
          }
        />
      </section>
    </OpenConstructionCostRoot>
  );
};

/**
 * attributes.content — 레거시 #open_construction_cost_content.innerHTML 과 같은 마크업.
 * 레거시 조회 화면이 이 HTML 을 그대로 넣고 자체 CSS·토글로 그림
 */
export const buildOpenConstructionCostContentHtml = (
  data: unknown[],
): string => {
  const view = mapAiResult(data);
  if (!view) return '';
  return renderToStaticMarkup(
    <OpenConstructionCostReport
      view={view}
      basisMode={initialBasisMode(view)}
    />,
  );
};

export default OpenConstructionCostInfo;
